<template>
  <IconWrapper name="more-options" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="6" r="1" fill="#1B1B1E" />
      <circle cx="12" cy="12" r="1" fill="#1B1B1E" />
      <circle cx="12" cy="18" r="1" fill="#1B1B1E" />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
}>()
</script>
